import { Directive, Input } from '@angular/core'

@Directive({
	selector: '[lowgileStepValue]',
})
export class StepValueDirective<T = any> {
	private value: T
	constructor() {}

	@Input() set lowgileStepValue(value: T) {
		this.value = value
	}

	getValue() {
		return this.value
	}
}
